<template>
  <v-main >
    <router-view />
  </v-main>
</template>

<script>
export default {
  computed: {
    backgroundClass() {
    if(this.$route.path == '/my-data-rights-form' || this.$route.path == '/login-account'){
        return 'bg-contact-bg'
      }else if(this.$route.path == '/'){
        return 'bg-home-background'
      }else{
        
      }
    }
  }
};
</script>

<style scoped>
/* Base styles */
::v-deep(.v-main__wrap) {
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}

/* Background classes for different routes */
.bg-contact-bg ::v-deep(.v-main__wrap) {
  background-image: url('/public/contact-bg.png') !important;
  background-size: cover !important;
   background-position: center !important;
  background-repeat: no-repeat !important;
}

.bg-home-background ::v-deep(.v-main__wrap) {
  background-image: url('/public/home-background.png') !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}
</style>